<template>
    <svg
        id="eZ6zygGO4Av1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 408 230"
        shape-rendering="geometricPrecision"
        text-rendering="geometricPrecision"
    >
        <path
            d="M180.647,97.7312h-167.4156v7.0788h167.4156v-7.0788Z"
            transform="translate(106.999476 48.529372)"
            fill="#0f1215"
        />
        <path
            d="M180.647,97.7312h-167.4156v7.0788h167.4156v-7.0788Z"
            transform="translate(106.999476 48.529372)"
            fill="#fff"
            fill-opacity="0.16"
        />
        <path
            d="M186.262,0.588257h-178.58378c-4.04501,0-7.305173,3.212323-7.305173,7.197983v102.67576c0,3.985,3.260163,7.198,7.305173,
                7.198h78.30418v7.614h-44.797v7.079h111.6306v-7.079h-44.797v-7.674h78.304c4.045,0,7.305-3.212,7.305-7.198v-102.61576c-.06-3.98566-3.321-7.197983-7.366-7.197983ZM100.834,
                125.214h-7.7276v-7.614h7.7276v7.614Zm85.549-14.752c0,.059-.06.119-.121.119h-178.58378c-.06037,0-.12075-.06-.12075-.119v-102.67576c0-.05949.06038-.11898.12075-.11898h178.58378c.061,
                0,.121.05949.121.11898v102.67576v0Z"
            transform="translate(106.999477 48.529372)"
            fill="#0f1215"
        />
        <path
            d="M186.262,0.588257h-178.58378c-4.04501,0-7.305173,3.212323-7.305173,7.197983v102.67576c0,3.985,3.260163,7.198,7.305173,
                7.198h78.30418v7.614h-44.797v7.079h111.6306v-7.079h-44.797v-7.674h78.304c4.045,0,7.305-3.212,7.305-7.198v-102.61576c-.06-3.98566-3.321-7.197983-7.366-7.197983ZM100.834,
                125.214h-7.7276v-7.614h7.7276v7.614Zm85.549-14.752c0,.059-.06.119-.121.119h-178.58378c-.06037,0-.12075-.06-.12075-.119v-102.67576c0-.05949.06038-.11898.12075-.11898h178.58378c.061,
                0,.121.05949.121.11898v102.67576v0Z"
            transform="translate(106.999477 48.529372)"
            fill="#fff"
            fill-opacity="0.16"
        />
    </svg>
</template>
